import React, { useCallback } from 'react';

import { Form, Input, Button } from '@kufox/mui';

import { useDispatch, useSelector } from 'react-redux';
import { REGEXP, useFormValidateByLang } from '../../common/tools';

import InputSendCode from '../../components/InputSendCode';

import { LOCAL_EMAIL_INPUT_KEY, NAMESPACE } from '../constants';

import { useToast, useLang } from '../../hookTool';

const { FormItem } = Form;

const sendChannel = 'EMAIL';

const ForgetEmailPwd = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const toast = useToast();
  const {
    t,
    i18n: { language },
  } = useLang();

  const { isCount, loading, EMAIL_countTime, bizType } = useSelector((state) => state[NAMESPACE]);

  const handleSendCode = useCallback(() => {
    form.validateFields(['email']).then(({ email }) => {
      dispatch({
        type: `${NAMESPACE}/sendVerifyCode`,
        payload: {
          email,
          bizType,
          toast,
          sendChannel,
        },
      });
    });
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e && e.preventDefault();
    // 校验表单值
    form.validateFields().then((values) => {
      const { email, code, password } = values;
      const payload = {
        email,
        code,
        toast,
        password,
        sendChannel,
      };
      dispatch({
        type: `${NAMESPACE}/verifyCode`,
        payload: { ...payload, bizType },
      });
    });
  }, []);

  const commonRule = [{ required: true, whitespace: true, message: t('form.required') }];
  useFormValidateByLang(form, language);

  return (
    <Form form={form}>
      <FormItem
        label={t('email')}
        name="email"
        initialValue={localStorage.getItem(LOCAL_EMAIL_INPUT_KEY) || ''}
        rules={[
          ...commonRule,
          {
            pattern: REGEXP.email,
            message: t('form.email.error'),
          },
        ]}
        validateTrigger={['onBlur', 'onSubmit']}
      >
        <InputSendCode
          onSendCode={handleSendCode}
          isCount={isCount}
          loading={loading}
          disabled={false}
          countTime={EMAIL_countTime}
          placeholder={t('email')}
        />
      </FormItem>
      <FormItem
        label={t('vc.email')}
        name="code"
        rules={commonRule}
        validateTrigger={['onBlur', 'onSubmit']}
      >
        <Input size="large" />
      </FormItem>
      <Button mt={34} type="primary" fullWidth size="large" onClick={handleSubmit}>
        {t('forget.btn')}
      </Button>
    </Form>
  );
};

export default ForgetEmailPwd;
